import emailIcon from "@assets/icon-email.svg";
import facebookIcon from "@assets/icon-facebook.svg";
import instagramIcon from "@assets/icon-instagram.svg";
import linkedinIcon from "@assets/icon-linkedin.svg";
import telegramIcon from "@assets/icon-telegram.svg";
import twitterIcon from "@assets/icon-twitter.svg";
import whatsappIcon from "@assets/icon-whatsapp.svg";
import closeWhite from "@assets/icons/icon-close-white.svg";
import giftIcon from "@assets/icons/icon-gift.svg";
import hamburgerForDesktopIcon from "@assets/icons/icon-hamburger-desktop.svg";
import hamburgerForMobileIcon from "@assets/icons/icon-hamburger-mobile.svg";
import linkIcon from "@assets/icons/icon-link.svg";
import profileIcon from "@assets/icons/icon-profile.svg";
import searchIcon from "@assets/icons/icon-search.svg";
import shareIcon from "@assets/icons/icon-share.svg";

import { IconTypeEnum } from "./types";

export const getIconSrc = (icon: IconTypeEnum) => {
  switch (icon) {
    case IconTypeEnum.facebook:
      return facebookIcon;

    case IconTypeEnum.telegram:
      return telegramIcon;

    case IconTypeEnum.email:
      return emailIcon;

    case IconTypeEnum.linkedin:
      return linkedinIcon;

    case IconTypeEnum.twitter:
      return twitterIcon;

    case IconTypeEnum.whatsapp:
      return whatsappIcon;

    case IconTypeEnum.instagram:
      return instagramIcon;

    case IconTypeEnum.profile:
      return profileIcon;

    case IconTypeEnum.search:
      return searchIcon;

    case IconTypeEnum.hamburgerForDesktop:
      return hamburgerForDesktopIcon;

    case IconTypeEnum.hamburgerForMobile:
      return hamburgerForMobileIcon;

    case IconTypeEnum.gift:
      return giftIcon;

    case IconTypeEnum.closeWhite:
      return closeWhite;

    case IconTypeEnum.share:
      return shareIcon;

    case IconTypeEnum.link:
      return linkIcon;
  }
};
